var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"company-profile-container"},[_c('span',{staticClass:"company-profile-content"},[_vm._v(_vm._s(_setup.renderContent))])])
}
var staticRenderFns = []

export { render, staticRenderFns }